
import { mapGetters } from 'vuex';
import SubItem from './SubItem.vue';

const page = {
    components: {
        SubItem
    },
    computed: {
        ...mapGetters([
            'routes',
        ]),
        activeMenu() {
            const route = this.$route
            const { meta, path } = route
            if (meta.activeMenu) {
                return meta.activeMenu
            }
            return path
        }
    }
}
export default page


// WEBPACK FOOTER //
// ./src/layout/master/components/sidebar/index.js